import { ORG_SUBSCRIPTION_PLANS } from "../constants/billing";
import { useAppStore } from "./useStores";

export interface ApiLimitStatus {
	orgUsage: number;
	freeLimit: number;
	freeLimitWarningThreshold: number;
	isAboutToBreakLimit: boolean;
	isPassedFreeLimit: boolean;
}

export const useApiLimitStatus = (): ApiLimitStatus => {
	const { authStore } = useAppStore();

	const orgUsage = authStore.orgUsage?.apiUsage ?? 0;
	const freeLimit = authStore.orgUsage?.apiFreeCallsLimit ?? 1000;
	const freeLimitWarningThreshold = freeLimit - freeLimit * 0.2;
	const isAboutToBreakLimit = orgUsage >= freeLimitWarningThreshold && orgUsage < freeLimit;
	const isPayingOrg = authStore.orgSubscription?.plan_name !== ORG_SUBSCRIPTION_PLANS.free.name;
	const isPassedFreeLimit = (authStore.orgPassedFreeLimit || isAboutToBreakLimit) && !isPayingOrg;

	return {
		orgUsage,
		freeLimit,
		freeLimitWarningThreshold,
		isAboutToBreakLimit,
		isPassedFreeLimit,
	};
};
